// Smart Sash Admin Panel - Hood Usage Report Page
// Full report with cascading filters, sortable table, and pagination

import React from 'react';
import { useHoodUsageReport } from '@/hooks/useHoodUsageReport';
import { HoodUsageFilters } from './HoodUsageFilters';
import { HoodUsageTable } from './HoodUsageTable';

export const HoodUsageReport: React.FC = () => {
  const {
    sessions,
    pagination,
    isLoading,
    error,
    filters,
    setInstitutionIds,
    setGroupIds,
    setLabIds,
    setUserIds,
    setDateRange,
    clearFilters,
    availableInstitutions,
    availableGroups,
    availableLabs,
    availableUsers,
    sort,
    setSort,
    page,
    pageSize,
    setPage,
    setPageSize,
  } = useHoodUsageReport();

  return (
    <div className="container-fluid py-4">
      <div className="mb-4">
        <h1 className="h3 mb-1">Hood Usage Report</h1>
        <p className="text-muted mb-0">Monitor fume hood usage sessions across facilities</p>
      </div>

      {error && (
        <div className="alert alert-danger alert-dismissible fade show" role="alert">
          {error}
          <button type="button" className="btn-close" data-bs-dismiss="alert"></button>
        </div>
      )}

      <HoodUsageFilters
        filters={filters}
        availableInstitutions={availableInstitutions}
        availableGroups={availableGroups}
        availableLabs={availableLabs}
        availableUsers={availableUsers}
        onInstitutionChange={setInstitutionIds}
        onGroupChange={setGroupIds}
        onLabChange={setLabIds}
        onUserChange={setUserIds}
        onDateRangeChange={setDateRange}
        onClear={clearFilters}
      />

      <HoodUsageTable
        sessions={sessions}
        sort={sort}
        onSort={setSort}
        pagination={pagination}
        page={page}
        pageSize={pageSize}
        onPageChange={setPage}
        onPageSizeChange={setPageSize}
        isLoading={isLoading}
      />
    </div>
  );
};

export default HoodUsageReport;
